// Single source of truth for StayMii press releases.
// Add a new entry here and it automatically appears on /press and the homepage news strip.
export const PRESS_RELEASES = [
  {
    slug: '/press/beds24-e-invoice-official-launch',
    date: '23 October 2026',
    dateIso: '2026-10-23',
    tag: 'Product Launch',
    title: 'StayMii\u2122 & Beds24 e-Invoice Integration Officially Launches in Malaysia',
    dek: 'Live from 23 October 2026: connect Beds24 with StayMii to generate and submit e-Invoices to LHDN MyInvois automatically \u2014 simpler, smarter and LHDN compliant for Malaysian hotels.',
    image: '/og/staymii-beds24-official-launch.jpg',
    imageFit: 'contain',
    imageBg: 'bg-white',
  },
  {
    slug: '/press/staymii-launches-sgmc-nice-2026',
    date: '27 August 2026',
    dateIso: '2026-08-27',
    tag: 'Product Launch',
    title: 'StayMii\u2122 Launches StayMii Global Market Connect (SGMC) to Bring Malaysian Experiences to the World',
    dek: 'Launched at NICE 2026, KLCC \u2014 officiated by Prime Minister Dato\u2019 Seri Anwar Ibrahim and witnessed by MOSTI Minister Datuk Chang Lih Kang \u2014 SGMC helps Malaysian attractions and experiences reach regional and international travellers, alongside a strategic MOU with GlobalTix.',
    image: '/og/staymii-sgmc-launch.jpg',
    imageFit: 'cover',
  },
  {
    slug: '/press/staymii-globaltix-mou-nice-2026',
    // Hidden from the /press hub and homepage news strip (and from search —
    // see backend NOINDEX_PAGES). The direct URL still works for sharing.
    hidden: true,
    date: '20 August 2026',
    dateIso: '2026-08-20',
    tag: 'Partnership',
    title: 'StayMii\u2122 and GlobalTix to Sign Strategic MoU at NICE 2026, KLCC',
    dek: 'FOR IMMEDIATE RELEASE: StayMii announces it will sign a Memorandum of Understanding with Singapore-based travel technology company GlobalTix on 27 August 2026 at the National Innovation and Commercialisation Expo (NICE 2026), Kuala Lumpur Convention Centre (KLCC).',
    image: '/og/staymii-globaltix-mou.jpg',
    imageFit: 'cover',
  },
  {
    slug: '/press/ihcc-eticketing-partnership',
    date: '5 August 2026',
    dateIso: '2026-08-05',
    tag: 'Partnership',
    title: 'IHCC Penang Appoints StayMii\u2122 as E-Ticketing Technology Partner',
    dek: 'The Indian Heritage Cultural Centre (IHCC) Penang joins the StayMii Global Market Connect (SGMC) Program with QR Code e-ticketing, digital visitor management and market distribution.',
    image: 'https://customer-assets-agu9un31.emergentagent.net/job_c028bd7b-503b-42cb-90d1-b73b8a5f884d/artifacts/qzsvkcfj_4f5be93f-dd74-444e-88b2-a121bbbb59ed.jpeg',
    imageFit: 'cover',
  },
  {
    slug: '/press/staymii-mysti-certified',
    date: '30 June 2026',
    dateIso: '2026-06-30',
    tag: 'Certification',
    title: 'StayMii\u2122 Awarded MySTI Certification by MOSTI for Locally Developed R&D Innovation',
    dek: 'Malaysia\u2019s Ministry of Science, Technology and Innovation (MOSTI) certifies StayMii\u2019s Automated E-Invoicing & Hospitality Management Platform as a recognised local R&D product, effective 30 June 2026.',
    image: '/og/mysti-certified.jpg',
    imageFit: 'contain',
    imageBg: 'bg-white',
  },
  {
    slug: '/press/beds24-e-invoice-soft-launch',
    date: '16 July 2026',
    dateIso: '2026-07-16',
    tag: 'Product Launch',
    title: 'StayMii\u2122 Announces Beds24 e-Invoice Integration for Malaysia \u2014 Soft Launching 16 July 2026',
    dek: 'The Beds24 \u2192 LHDN MyInvois integration automates tax-compliant e-invoicing for Malaysian hotels, serviced apartments and short-term rental operators.',
    image: 'https://customer-assets-agu9un31.emergentagent.net/job_c028bd7b-503b-42cb-90d1-b73b8a5f884d/artifacts/t05s0qot_26608CC9-410D-493E-8C97-BDC7AF9B91AF.png',
    imageFit: 'contain',
    imageBg: 'bg-white',
  },
];

// Newest first (descending by publish date). Excludes releases flagged
// `hidden` so they don't appear on the /press hub or homepage news strip
// (the direct URL still resolves for social sharing / distribution links).
export const getSortedReleases = () =>
  PRESS_RELEASES.filter((r) => !r.hidden).sort((a, b) => b.dateIso.localeCompare(a.dateIso));

// The N newest releases.
export const getLatestReleases = (n = 3) => getSortedReleases().slice(0, n);
